<template>
  <NavigationToolbar :title="title">
    <template slot="toolbar-action">
      <v-btn icon to="/qr" :disabled="!isAppOnline"><QrCode/></v-btn>
    </template>
    <OnlyOnline>
      <Spinner
      :loading="loading"
      :spinnerClasses="spinnerClasses">
        <ResponsibleSearch v-if="!isListReadyToShow" key="select-responsible"/>
        <StudentsReleaseList v-else-if="!error && isListReadyToShow" key="student-release-list"/>
        <ResponsibleError v-else key="responsible-error"/>
      </Spinner>
    </OnlyOnline>
  </NavigationToolbar>
</template>

<script>
import NavigationToolbar from '@/layouts/NavigationToolbar'
import OnlyOnline from '@/components/OnlyOnline'
import QrCode from '@/components/icons/QrCode'
import ResponsibleError from './ResponsibleError'
import ResponsibleSearch from './ResponsibleSearch'
import Spinner from '@/components/Spinner'
import StudentsReleaseList from './StudentsReleaseList'

import { mapState, mapActions } from 'vuex'

export default {
  components: {
    NavigationToolbar,
    OnlyOnline,
    QrCode,
    ResponsibleError,
    ResponsibleSearch,
    Spinner,
    StudentsReleaseList
  },

  data: () => ({
    spinnerClasses: 'fill-height',
    title: 'Solicitação de Saída'
  }),

  computed: {
    ...mapState({
      error: state => state.responsibleInfos.error,
      isListReadyToShow: state => state.responsibleInfos.isListReadyToShow,
      loading: state => state.responsibleInfos.loading,
      sendStudentsMessage: state => state.responsibleInfos.sendStudentsMessage,
      isAppOnline: state => state.network.online
    })
  },

  watch: {
    sendStudentsMessage (newValue) {
      if (newValue) {
        this.showSnack(newValue)
      }
    }
  },

  mounted () {
    this.resetStore()
  },

  methods: {
    ...mapActions({
      resetStore: 'responsibleInfos/resetStore',
      showSnack: 'snackbar/showSnack'
    })
  }
}
</script>
